import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/live';
import * as css from './MemberListError.css';

interface MemberListErrorProps {
    /* Nothing loaded at all — the message takes the whole sheet instead of sitting under a list */
    initial?: boolean;
    onRetry: () => void;
    'data-cy'?: string;
}

/* A page that failed to arrive is not an empty list: telling a member "no tickets yet" because the
   connection dropped is the opposite message, and leaves no way on other than reloading the page. */
function MemberListError({initial, onRetry, 'data-cy': dataCy}: MemberListErrorProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.wrap $initial={initial} data-cy={dataCy}>
            <css.text>{t('listLoadError')}</css.text>
            <Button variant="neutral" size="chip" onClick={onRetry} data-cy={dataCy && `${dataCy}-retry`}>
                {t('retry')}
            </Button>
        </css.wrap>
    );
}

export default MemberListError;
